import { SVGProps } from '../types';

const FilePdfIcon = (props: SVGProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8 0.45H14.4C14.4727 0.45 14.5425 0.478853 14.5939 0.530273L21.0697 7.00608C21.1211 7.0575 21.15 7.12728 21.15 7.2V21.6C21.15 22.6769 20.2769 23.55 19.2 23.55H4.8C3.72304 23.55 2.85 22.6769 2.85 21.6V2.4C2.85 1.32304 3.72305 0.45 4.8 0.45Z"
      fill="white"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
    <path
      d="M14.4 0.3V4.8C14.4 6.12546 15.4745 7.2 16.8 7.2H21.3"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
    <path
      d="M15.4253 15.2064C14.7516 15.2064 13.9085 15.3239 13.6327 15.3653C12.491 14.1731 12.1662 13.4954 12.0932 13.3148C12.1922 13.0604 12.5366 12.094 12.5856 10.8528C12.6097 10.2314 12.4785 9.7671 12.1954 9.47274C11.9127 9.17886 11.5706 9.156 11.4725 9.156C11.1285 9.156 10.5514 9.32994 10.5514 10.4948C10.5514 11.5055 11.0227 12.578 11.1529 12.8551C10.4666 14.8534 9.72978 16.2214 9.57336 16.5026C6.81564 17.5409 6.6 18.5449 6.6 18.8294C6.6 19.3407 6.96414 19.6459 7.57404 19.6459C9.05592 19.6459 10.4082 17.158 10.6318 16.726C11.6843 16.3067 13.093 16.0469 13.451 15.985C14.4782 16.9634 15.6662 17.2245 16.1596 17.2245C16.5307 17.2245 17.3999 17.2245 17.3999 16.3308C17.4 15.5009 16.3363 15.2064 15.4253 15.2064ZM15.3539 15.7931C16.1543 15.7931 16.3658 16.0579 16.3658 16.1978C16.3658 16.2856 16.3325 16.5722 15.9035 16.5722C15.5188 16.5722 14.8545 16.3498 14.201 15.8674C14.4735 15.8315 14.8768 15.7931 15.3539 15.7931ZM11.4305 9.72474C11.5034 9.72474 11.5515 9.74814 11.5911 9.8031C11.8213 10.1225 11.6357 11.1663 11.4098 11.9831C11.1917 11.2828 11.028 10.2081 11.2583 9.83004C11.3033 9.75624 11.3548 9.72474 11.4305 9.72474ZM11.0417 15.9766C11.3315 15.3912 11.6563 14.538 11.8332 14.0554C12.1873 14.648 12.6634 15.1982 12.9388 15.4965C12.0814 15.6773 11.4326 15.8579 11.0417 15.9766ZM7.17564 18.9075C7.15656 18.8849 7.15374 18.8371 7.16814 18.7798C7.19826 18.6597 7.42884 18.0644 9.09648 17.3185C8.85768 17.6946 8.48442 18.232 8.07432 18.6335C7.78566 18.9037 7.56084 19.0407 7.40622 19.0407C7.3509 19.0407 7.27464 19.0256 7.17564 18.9075Z"
      fill="#A82E21"
    />
  </svg>
);

export { FilePdfIcon };
